import { Pipe, PipeTransform, Inject } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'packageTotalItems'
})
export class PackageTotalItemsPipe implements PipeTransform {

  constructor(
    @Inject('splitService') private splitService
  ) {}

  transform(packageList: any[]): string {
    let totalItemsCount = 0;

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          totalItemsCount += pkg.items.reduce((res, item) => {
            res += (item.count || 1);
            return res;
          }, 0);
        }
      });
    }

    return `${totalItemsCount}`;
  }
}





// import {Pipe, PipeTransform, Inject} from '@angular/core';
//
// @Pipe({
//   name: 'packageTotalItems'
// })
// export class PackageTotalItemsPipe implements PipeTransform {
//
//   constructor(
//     @Inject('splitService') private splitService
//   ) {
//   }
//
//   transform(packageRef: any): string {
//     let packagesTotalItemsCount = 0;
//
//     if (packageRef && packageRef.items?.length) {
//       packagesTotalItemsCount = packageRef.items.reduce((res, item) => {
//         res += (item.count || 1);
//         return res;
//       }, 0);
//     }
//
//     return `${packagesTotalItemsCount}`;
//   }
// }
